import { isNil } from "lodash";

const RELEASE_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

// Pulls the calendar year/month/day straight out of the ISO string the API sends, without ever
// building a Date object. The column is a `timestamp without time zone` holding a calendar date,
// not an instant, so parsing it through `new Date(...)` and reading local getters would apply the
// viewer's timezone offset and could report the wrong day (or even the wrong year, near midnight
// UTC) for anyone behind UTC.
function parseReleaseDate(releaseDate) {
    if (isNil(releaseDate)) {
        return null;
    }
    const match = RELEASE_DATE_PATTERN.exec(releaseDate);
    if (!match) {
        return null;
    }
    return {
        year: parseInt(match[1], 10),
        month: parseInt(match[2], 10),
        day: parseInt(match[3], 10),
    };
}

/**
 * Formats an album's release date in full, e.g. "14 Mar 2026".
 *
 * A release recorded with no month or day is stored as 1 January of that year, which is
 * indistinguishable from an actual 1 January release — both render the same ordinary date.
 *
 * @param {{ releaseDate: ?string }} album
 * @param {function} t i18next translate function
 * @returns {string}
 */
export function formatReleaseDate(album, t) {
    const parsed = isNil(album) ? null : parseReleaseDate(album.releaseDate);
    if (isNil(parsed)) {
        return "";
    }
    const month = t(`COMMON.MONTHS.SHORT.${parsed.month}`);
    return `${parsed.day} ${month} ${parsed.year}`;
}

/**
 * Formats only the release year, e.g. "2026" — used in the end-user portal, which shows no more
 * precision than that.
 *
 * @param {{ releaseDate: ?string }} album
 * @returns {string}
 */
export function formatReleaseYear(album) {
    const parsed = isNil(album) ? null : parseReleaseDate(album.releaseDate);
    return isNil(parsed) ? "" : `${parsed.year}`;
}
